import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (item) => {
    if (item.id === 'about') {
      navigate('/about');
      setIsOpen(false);
      return;
    }

    if (item.id === 'contact') {
      navigate('/contact');
      setIsOpen(false);
      return;
    }

    if (item.id === 'products') {
      navigate('/products');
      setIsOpen(false);
      return;
    }

    if (item.id === 'blog') {
      navigate('/blog');
      setIsOpen(false);
      return;
    }

    if (location.pathname !== '/') {
      navigate('/#' + item.id);
      setIsOpen(false);
      return;
    }

    const element = document.getElementById(item.id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  const navItems = [
    { label: 'Home', id: 'hero' },
    { label: 'Products', id: 'products' },
    { label: 'Our Expertise', id: 'our-expertise' },
    
    { label: 'Services', id: 'services' },
    { label: 'Blog', id: 'blog' },
    { label: 'About', id: 'about' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 bg-dark shadow-soft z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/">
              <motion.div
                whileHover={{ scale: 1.05 }}
                className=" font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent cursor-pointer"
              >
                <img src="assets/img/logo.png" 
                alt="logo" 
                className="h-10 w-auto object-contain" 
                />
              </motion.div>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-1">
            {navItems.map((item, index) => (
              <motion.button
                key={index}
                onClick={() => handleNavClick(item)}
                whileHover={{ color: '#E53935' }}
                className={`px-3 py-2 transition-colors duration-200 text-sm font-medium ${(location.pathname === '/about' && item.id === 'about') ||
                  (location.pathname === '/contact' && item.id === 'contact') ||
                  (location.pathname === '/' && item.id === 'hero')
                  ? 'text-primary'
                  : 'text-white hover:text-primary'
                  }`}
              >
                {item.label}
              </motion.button>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => window.location.href = '/contact?subject=Demo Request'}
              className="bg-primary hover:bg-secondary text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200"
            >
              Request Demo
            </motion.button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-primary focus:outline-none"
            >
              {isOpen ? (
                <X size={24} />
              ) : (
                <Menu size={24} />
              )}
            </motion.button>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden pb-4 space-y-2 overflow-hidden"
            >
              {navItems.map((item, index) => (
                <motion.button
                  key={index}
                  onClick={() => handleNavClick(item)}
                  whileHover={{ x: 10 }}
                  className={`block w-full text-left px-3 py-2 transition-colors duration-200 font-medium ${(location.pathname === '/about' && item.id === 'about') ||
                    (location.pathname === '/contact' && item.id === 'contact')
                    ? 'text-red-500'
                    : 'text-white hover:text-primary'
                    }`}
                >
                  {item.label}
                </motion.button>
              ))}
              <motion.button
                whileHover={{ scale: 1.02 }}
                onClick={() => window.location.href = '/contact?subject=Demo Request'}
                className="w-full bg-primary hover:bg-secondary text-white px-6 py-2 rounded-lg font-medium transition-colors duration-200 mt-2"
              >
                Request Demo
              </motion.button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.nav>
  );
};

export default Navbar;
